import {put, takeEvery, call} from 'redux-saga/effects';
import {
    FEEDBACK_QUALITY_SUBMIT,
    FEEDBACK_QUALITY_SUBMIT_REQUEST,
    FEEDBACK_QUALITY_SUBMIT_SUCCESS,
    FEEDBACK_QUALITY_SUBMIT_FAILURE
} from '../constants';
import Api, {ApiMethods} from 'feedback-system/middleware/api';

function* qualityFeedbackSubmit(action: any) {
    try {
        yield put({type: FEEDBACK_QUALITY_SUBMIT_REQUEST});
        const data = yield call(Api.fetch, {
            endpoint: `feedback/submit/${action.periodId}/all`,
            method: ApiMethods.PUT,
            body: action.feedbacks
        });
        yield put({type: FEEDBACK_QUALITY_SUBMIT_SUCCESS, submitedFeedback: data.responseData});
    } catch (e) {
        yield put({type: FEEDBACK_QUALITY_SUBMIT_FAILURE, error: e});
    }
}

function* qualityFeedbackSagaSubmit() {
    yield takeEvery(FEEDBACK_QUALITY_SUBMIT, qualityFeedbackSubmit);
}

export default qualityFeedbackSagaSubmit;
